export const calculateClothoideParameter = ({firstRadius, secondRadius, superelevationRunoffLength}) => {
    let A = 0;
    if(!secondRadius) A = Math.sqrt(Math.abs(firstRadius) * superelevationRunoffLength);
    else if(secondRadius === firstRadius) A = 0;   
    else A = Math.sqrt(superelevationRunoffLength/Math.abs((1/firstRadius) - (1/secondRadius)));
    
    return Math.ceil(A /5 ) * 5;
}